import {EAuthRole} from "../types/auth";

function fn(role: EAuthRole): boolean {
    return role === EAuthRole.PLATFORM_ADMIN;
}

export default fn;
